import { submitSucceeded } from 'circe/forms/actions';
import { SHIPMENT_STATUS } from 'domain/shipment/constants';
import { FORM_NAME } from 'domain/operations/drivers/itineraryStatus/unScheduleItinerary/constants';
import actionTypes from './actionTypes';

const initialState = {
  isFetching: true,
  isMarkingAsCollected: false,
  isConfirmingCashCollected: false,
  isMarkingAsReceived: false,
  isUpdatingRecipient: false,
  isUpdateRecipientScreenOpened: false,
  summary: {
    totalCod: {
      amount: 0,
    },
    totalConfirmedCod: {
      amount: 0,
    },
    totalCodNeedConfirm: {
      amount: 0,
    },
  },
  shipments: [],
  bayanId: null,
  closed: false,
  codCollectionClosed: false,
  waybillReceivingClosed: false,
  isAttaching: false,
  isDeattaching: false,
  isRearranging: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH: {
      return {
        ...state,
        data: {},
        isFetching: true,
      };
    }

    case actionTypes.FETCHED: {
      return {
        ...state,
        isFetching: false,
        summary: action.payload.data.summary,
        shipments: action.payload.data.shipments,
        codCollectionClosed: action.payload.data.codCollectionClosed,
        waybillReceivingClosed: action.payload.data.waybillReceivingClosed,
        bayanId: action.payload.data.bayanId,
      };
    }
    case actionTypes.MARK_AS_COLLECTED:
      return {
        ...state,
        isMarkingAsCollected: true,
      };

    case actionTypes.MARKED_AS_COLLECTED:
      return {
        ...state,
        summary: {
          ...state.summary,
          closed: true,
        },
        isMarkingAsCollected: false,
      };

    case actionTypes.MARK_AS_RECEIVED:
      return {
        ...state,
        isMarkingAsReceived: true,
      };

    case actionTypes.MARKED_AS_RECEIVED:
      return {
        ...state,
        shipments: state.shipments.map((shipment) => {
          if (action.payload.shipmentIds.includes(shipment.shipmentId)) {
            return {
              ...shipment,
              received: true,
            };
          }
          return shipment;
        }),
        isMarkingAsReceived: false,
        waybillReceivingClosed: true,
      };

    case actionTypes.CONFIRM_CASH_COLLECTED:
      return {
        ...state,
        isConfirmingCashCollected: true,
      };

    case actionTypes.CONFIRMED_CASH_COLLECTED:
      return {
        ...state,
        isConfirmingCashCollected: false,
        codCollectionClosed: true,
      };

    case actionTypes.ATTACH_TO_ITINERARY:
      return {
        ...state,
        isAttaching: true,
      };

    case actionTypes.SHIPMENT_ATTACHED:
      return {
        ...state,
        isAttaching: false,
      };

    case actionTypes.DEATTACH_FROM_ITINERARY:
      return {
        ...state,
        isDeattaching: true,
      };

    case actionTypes.SHIPMENT_DEATTACHED:
      return {
        ...state,
        isDeattaching: false,
      };

    case actionTypes.REARRANGE_SHIPMENTS:
      return {
        ...state,
        isRearranging: true,
      };

    case actionTypes.REARRANGE_DONE:
      return {
        ...state,
        isRearranging: false,
      };

    case submitSucceeded().type:
      if (action.payload.name !== FORM_NAME) {
        return state;
      }

      return {
        ...state,
        shipments: state.shipments.map((shipment) => ({
          ...shipment,
          status: SHIPMENT_STATUS.UNASSIGNED,
        })),
      };

    case actionTypes.UPDATE_RECIPIENT:
      return {
        ...state,
        isUpdatingRecipient: true,
      };
    case actionTypes.UPDATED_RECIPIENT:
      return {
        ...state,
        isUpdatingRecipient: false,
        isUpdateRecipientScreenOpened: false,
      };

    case actionTypes.TOGGLE_UPDATE_RECIPIENT_SCREEN:
      return {
        ...state,
        isUpdateRecipientScreenOpened: !state.isUpdateRecipientScreenOpened,
      };

    default:
      return state;
  }
};
